export class NativeStreamStatsConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "maxColumns",
            "baseName": "maxColumns",
            "type": "number",
            "format": ""
        },
        {
            "name": "eventTimeColumn",
            "baseName": "eventTimeColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "persistIntervalDrains",
            "baseName": "persistIntervalDrains",
            "type": "number",
            "format": ""
        },
        {
            "name": "categoricalMaxNdv",
            "baseName": "categoricalMaxNdv",
            "type": "number",
            "format": ""
        },
        {
            "name": "topValuesEmitted",
            "baseName": "topValuesEmitted",
            "type": "number",
            "format": ""
        },
        {
            "name": "partitionSketchesEnabled",
            "baseName": "partitionSketchesEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "freeStatsAllColumns",
            "baseName": "freeStatsAllColumns",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "columnOverrides",
            "baseName": "columnOverrides",
            "type": "{ [key: string]: Array<NativeStreamStatKind>; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamStatsConfig.attributeTypeMap;
    }
    constructor() {
    }
}
